<div class="table-container">
  <form class="table-filter">
    <div>
      <span class="table-filter-row">
        <div class="table-filter-title">Mostrar: </div>
        <select class="form-control" id="qtdPorPagina" name="qtdPorPagina" [(ngModel)]="qtdPorPagina">
          <option value="30" selected="true">30</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        <div class="table-filter-title">registros</div>
      </span>
    </div>
    <div class="col-md-6 form-group table-filter-row">
      <div class="table-filter-title">Procurar</div>
        <input maxlength="100" type="search" class="form-control" [(ngModel)]="procurarItem" name="procurarItem" (keyup)="onKeyupProcurarItem()">
    </div>
  </form>

  <table class="table table-striped" aria-describedby="Listagem de propostas." aria-hidden="true">
    <thead>
      <tr>
        <td>
          <app-header-sort description="PROD." column="produto" [current]="currentSort" (sort)="currentSort.next($event)"></app-header-sort>
        </td>
        <td>
          <app-header-sort description="STATUS" column="statusTimeline.tituloStatus" [current]="currentSort" (sort)="currentSort.next($event)"></app-header-sort>
        </td>
        <td>
          <app-header-sort description="FICHA" column="id" [current]="currentSort" (sort)="currentSort.next($event)"></app-header-sort>
        </td>
        <td>
          <app-header-sort description="CLIENTE" column="cliente.nome" [current]="currentSort" (sort)="currentSort.next($event)"></app-header-sort>
        </td>
        <td>
          <app-header-sort description="VALOR" column="valorLiquido" [current]="currentSort" (sort)="currentSort.next($event)"></app-header-sort>
        </td>
        <td>
          <app-header-sort description="ANALISTA" column="statusTimeline.usuarioAcao" [current]="currentSort" (sort)="currentSort.next($event)"></app-header-sort>
        </td>
        <td>
          <app-header-sort description="DATA" column="dataHoraEnvio" [current]="currentSort" (sort)="currentSort.next($event)"></app-header-sort>
        </td>
        <td>
          <app-header-sort description="PRAZO" column="statusTimeline.cardEsquerdo" [current]="currentSort" (sort)="currentSort.next($event)"></app-header-sort>
        </td>
        <td *ngIf="isOperador">
          <app-header-sort description="LOJISTA" column="vendedor.nmLoja" [current]="currentSort" (sort)="currentSort.next($event)"></app-header-sort>
        </td>
        <td *ngIf="isOperador">
          <app-header-sort description="VENDEDOR" column="vendedor.nome" [current]="currentSort" (sort)="currentSort.next($event)"></app-header-sort>
        </td>
        <td *ngIf="isLojista">
          <app-header-sort description="OPERADOR" column="vendedor.nome" [current]="currentSort" (sort)="currentSort.next($event)"></app-header-sort>
        </td>
      </tr>
    </thead>

    <tbody class="table-body">
      <tr *ngFor="let proposta of fichasOrdenadas" class="table-row" [ngClass]="{'table-row-sos': proposta.totalSosPendente}" >
        <td>
          <div class="flex-container">
            <span [ngClass]="iconeProduto(proposta.produto)" (click)="goToTimeline(proposta)"></span>
            <span class="icon-pesados-brasil" [ngClass]="{
                      'visibility-hidden':
                        tipoPropostaEnum.PROPRIA === proposta.tipoProposta,
                      'icon-recebido-pesados-brasil':
                        tipoPropostaEnum.RECEBIDA === proposta.tipoProposta,
                      'icon-indicado-pesados-brasil':
                        tipoPropostaEnum.INDICADA === proposta.tipoProposta
                    }" [tooltip]="popTemplate" triggers="click" placement="right" containerClass="tooltip"
              (click)="getDadosPesadosBrasil(proposta)"></span>
          </div>
        </td>
        <td [innerHtml]="proposta.totalSosPendente ? proposta.statusTimeline.tituloStatus + sosText : proposta.statusTimeline.tituloStatus" (click)="goToTimeline(proposta)"></td>
        <td (click)="goToTimeline(proposta)">{{ proposta.id }}</td>
        <td (click)="goToTimeline(proposta)">
          <div>{{ proposta.cliente.nomeCliente }}</div>
          <div>{{ proposta.cliente.cpf | cpf }}</div>
        </td>
        <td (click)="goToTimeline(proposta)">{{ proposta.valorLiquido | currency:'BRL':'symbol' }}</td>
        <td (click)="goToTimeline(proposta)">{{ proposta.statusTimeline.usuarioAcao }}</td>
        <td (click)="goToTimeline(proposta)">{{ proposta.dataHoraEnvio | datetime }}</td>
        <td (click)="goToTimeline(proposta)">{{ getPrazoFromProposta(proposta) }}</td>
        <td *ngIf="isOperador" (click)="goToTimeline(proposta)">{{ proposta.vendedor.nmLoja }}</td>
        <td *ngIf="isOperador" (click)="goToTimeline(proposta)">{{ proposta.vendedor.nome }}</td>
        <td *ngIf="isLojista" title="setupTdTitle(proposta.vendedor)" (click)="goToTimeline(proposta)">{{ proposta.vendedor?.nome }}</td>
      </tr>
    </tbody>

  </table>

  <app-paginator *ngIf="numeroFichas > 0" [qtdPorPagina]="qtdPorPagina" [totalRegistros]="numeroFichas"
    [qtdAdjacentes]="1" (onPaginate)="paginar($event)"></app-paginator>
</div>

<app-modal-message #modalMessage [title]="'Atenção!'" [hideClose]="true"></app-modal-message>

<ng-template #popTemplate>
  <app-loader-default text="Buscando informações da proposta" [show]="isBuscandoProposta" size="fa-1x"></app-loader-default>
  {{toolTip}}
</ng-template>
